module.exports = "<div class=\"spinner-container\" *ngIf=\"showFlag\" [ngClass]=\"{'show': showFlag, 'hide': showFlag === false}\">\r\n  <md-spinner class=\"spinner\"></md-spinner>\r\n</div>\r\n\r\n<div class=\"top-spinner\" *ngIf=\"!showFlag\">\r\n  <div [ngClass]=\"{'show': showSoftFlag, 'hide': showSoftFlag === false}\">\r\n    <md-spinner></md-spinner>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/spinner/spinner.component.html
// module id = ../../../../../src/app/components/common/spinner/spinner.component.html
// module chunks = 0